module.exports = __webpack_public_path__ + "static/media/house1.fffad397.png";